import OneInput from "./input.vue";
const coms = [OneInput];
/* 
 vue.use(插件)  ==》 自动去插件的入口文件找到一个名字为install的函数
 install函数    ==》 注册并暴露出各个组件的方法
*/
const install = function (Vue) {
  coms.forEach((com) => {
    Vue.component(com.name, com);
  });
};
export default {
  install,
};
